import React from 'react';
import PageContentHeader from './components/PageContentHeader.js';
import './PageContentLayout.scss';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

const PageContentLayout = ({
  actions = null,
  actionsClassName = '',
  as: Component = 'div',
  bodyClassName = '',
  children,
  className = '',
  description = '',
  filters = null,
  filtersClassName = '',
  fill = false,
  pageClassName = '',
  title,
  titleAs = 'h2',
}) => (
  <Component
    className={joinClassNames(
      'page-content-layout-page',
      pageClassName,
    )}
  >
    <div
      className={joinClassNames(
        'page-content-layout',
        fill && 'page-content-layout--fill',
        className,
      )}
    >
      <PageContentHeader
        actions={actions}
        actionsClassName={actionsClassName}
        description={description}
        title={title}
        titleAs={titleAs}
      />
      {filters && (
        <section className={joinClassNames('page-content-layout__filters', filtersClassName)}>
          {filters}
        </section>
      )}
      <section className={joinClassNames('page-content-layout__body', bodyClassName)}>
        {children}
      </section>
    </div>
  </Component>
);

export default PageContentLayout;
